import React, { useEffect, useState } from "react";
import "./Loading.css";
import logo from "../../assets/icon/asten-global-logo-client.png"; // place the uploaded logo in src/assets

const Loading = () => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 1500); // show for 1.5s before fading out
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`loading-screen ${fadeOut ? "fade-out" : ""}`}>
      <img src={logo} alt="Ashten Global" className="loading-logo" />
    </div>
  );
};

export default Loading;